import * as t from 'io-ts';

// Intersection creates a new type from interface properties (required) and partial properties (optional).
export const ErrorMessageDynamicType = t.intersection([
    t.interface({
        text: t.string,
    }),
    t.partial({
        code: t.union([t.string, t.null]),
    })
]);

export type ErrorMessage = t.TypeOf<typeof ErrorMessageDynamicType>;
